import { selectGlobalDocumentNode } from '@newStore/documentUI/transformContent/globalDocumentSelectors';
import { selectValidateGlobalDocAudienceParentIntersectionNotEmpty } from '@newStore/validation/validationRules/audienceIntersectionRules';
import { selectNonFirstAttachmentInDownloadWarning } from '@newStore/validation/validationRules/nonFirstAttachmentDownloadWarning';
import {
  type BuildingBlockNodeConfig,
  RequiredType,
  type RootNodeConfig,
} from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { proAccessRightsComponent } from '@nodeTypeConfig/helpers/editComponents/proAccessRightsComponent';
import { proThemeAudienceTab } from '@nodeTypeConfig/helpers/editComponents/proThemeAudienceTab';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { globalDocumentDeleteValidationCmd } from '@store/commands/documentListCommands';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { accessRights } from '../../../reduxLoop/helpers/accessRights';
import { convertDateToUTCISOString } from '@UI/aside/asideDatePicker/dateHelper';

const GLOBAL_DOCUMENT: RootNodeConfig & BuildingBlockNodeConfig = {
  nodeSelector: selectGlobalDocumentNode,
  deleteFromListValidations: [globalDocumentDeleteValidationCmd],
  validationRules: [
    selectValidateGlobalDocAudienceParentIntersectionNotEmpty,
    selectNonFirstAttachmentInDownloadWarning,
  ],
  information: {
    definiteArticle: true,
    single: 'Gedeeld document',
    plural: 'Gedeelde documenten',
    ribonIcon: require('../../../../img/buildingBlocks/GLOBAL_DOCUMENT.svg'),
  },
  createDefaults: {
    accessRights: accessRights.publiek.namedsets,
    issued: convertDateToUTCISOString(new Date()),
  },
  buildingBlocks: [],
  tocTypes: [],
  createModal: {
    identifier: {},
    attachmentDocumentType: { required: true },
    authors: { addUser: true, required: true },
    uploadAttachment: { required: true },
  },
  websiteHref: null,
  edit: [
    {
      ...titleComponent,
      width: 10,
    },
    {
      ...identifierComponent,
      width: 2,
      label: 'Referentienummer',
    },
    {
      ...descriptionComponent,
      label: 'Inleiding / korte inhoud',
      required: RequiredType.WARNING,
    },
    {
      ...authorsComponent,
      required: RequiredType.ERROR,
    },
  ],
  audienceTab: proThemeAudienceTab,
  addAccessRightsToAudienceTab: {
    ...proAccessRightsComponent,
    property: 'accessRights',
  },
  isCreatable: true,
  isSearchable: true,
  isImportable: false,
  isCollapsible: false,
  onNewNodeDropped: {
    openAside: false,
  },
  allowSuggestions: false,
  onEditIncludedNode: (href) => {
    window.open(`/edit/${getResourceKey(href)}`, '_blank');
  },
};

export default GLOBAL_DOCUMENT;
